import React, {Suspense} from 'react';
import {Provider} from 'react-redux';
import store from './redux/redux';
import './App.global';
import useLoadScripts from './scripts/ScriptProvider';
import reCaptcha from './scripts/reCaptcha';
import Loader from './components/UI/Loader/Loader'
const Router = React.lazy(() => import('./Router'));



const App = (props) => {

    useLoadScripts({ src: reCaptcha });


    return (
        <Provider store={store}>
            <Suspense fallback={<Loader/>}>
                <Router />
            </Suspense>
        </Provider>
    );
};


export default App;